import React, { useState } from 'react'
import config from 'src/config'
import {
  getInvoicePreviewUrl,
  isInvoicePdfFile,
} from 'src/utils/invoiceUploadHelpers'

const tileContainerStyle = {
  width: '100%',
  height: 400,
  border: '1px solid #f0f0f0',
  borderRadius: 8,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#fff',
}

const zoomBaseStyle = {
  transition: 'transform 0.3s ease',
  cursor: 'zoom-in',
}

const SelectedPreviews = ({
  selectedFile,
  fileDataUrl,
  selectedInvoices,
  localPreviews = [],
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [zoomed, setZoomed] = useState(false)

  return (
    <>
      {localPreviews && localPreviews.length > 0 && (
        <div
          style={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: 16,
            marginTop: 16,
          }}
        >
          {localPreviews.map((preview, index) => (
            <div
              key={`local-${index}`}
              style={{ ...tileContainerStyle, padding: 8 }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {preview.isPdf ? (
                <embed
                  src={preview.dataUrl}
                  type='application/pdf'
                  width='100%'
                  height='100%'
                  style={{ pointerEvents: 'none' }}
                />
              ) : (
                <img
                  src={preview.dataUrl}
                  alt='Selected File'
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    ...zoomBaseStyle,
                    transform: hoveredIndex === index ? 'scale(2)' : 'scale(1)',
                  }}
                />
              )}
            </div>
          ))}
        </div>
      )}
      {selectedFile && (
        <div
          style={{ marginTop: 24 }}
          onMouseEnter={() => setZoomed(true)}
          onMouseLeave={() => setZoomed(false)}
        >
          {fileDataUrl &&
            (selectedFile.type.startsWith('image/') ? (
              <div style={tileContainerStyle}>
                <img
                  src={fileDataUrl}
                  alt='Preview'
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    ...zoomBaseStyle,
                    transform: zoomed ? 'scale(2)' : 'scale(1)',
                  }}
                />
              </div>
            ) : (
              <div style={tileContainerStyle}>
                <embed
                  src={fileDataUrl}
                  type='application/pdf'
                  width='100%'
                  height='100%'
                  style={{ pointerEvents: 'none' }}
                />
              </div>
            ))}
        </div>
      )}

      {selectedInvoices && selectedInvoices.length > 0 && (
        <div
          style={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: 16,
            marginTop: 16,
          }}
        >
          {selectedInvoices.map((invoice, index) => {
            const previewUrl = getInvoicePreviewUrl(
              invoice,
              config.apiGateway.EXPRESS_URL,
            )

            if (!previewUrl) {
              return (
                <div
                  key={`invoice-${invoice.id || index}`}
                  style={{ ...tileContainerStyle, padding: 16 }}
                >
                  <span style={{ color: '#8c8c8c' }}>
                    Preview unavailable for{' '}
                    {invoice.fileName || 'selected invoice'}
                  </span>
                </div>
              )
            }

            return (
              <div
                key={`invoice-${invoice.id || index}`}
                style={{ ...tileContainerStyle, padding: 8 }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {isInvoicePdfFile(invoice) ? (
                  <embed
                    src={previewUrl}
                    type='application/pdf'
                    width='100%'
                    height='100%'
                    style={{ pointerEvents: 'none' }}
                  />
                ) : (
                  <img
                    src={previewUrl}
                    alt='Selected Invoice'
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      ...zoomBaseStyle,
                      transform:
                        hoveredIndex === index ? 'scale(2)' : 'scale(1)',
                    }}
                  />
                )}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}

export default SelectedPreviews
